import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandHireflix(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="M4.800781 2.398438c-1.328125 0-2.402343 1.074218-2.402343 2.402343v14.398438c0 1.328125 1.074218 2.402343 2.402343 2.402343h.730469C6.144531 18.859375 8.808594 16.800781 12 16.800781s5.855469 2.058594 6.46875 4.800781h.730469c1.328125 0 2.402343-1.074218 2.402343-2.402343V4.800781c0-1.328125-1.074218-2.402343-2.402343-2.402343ZM15 12c0 1.65625-1.34375 3-3 3s-3-1.34375-3-3 1.34375-3 3-3 3 1.34375 3 3ZM5.699219 7.199219c.828125 0 1.5-.671875 1.5-1.5s-.671875-1.5-1.5-1.5-1.5.671875-1.5 1.5.671875 1.5 1.5 1.5Zm0 0"
        fillRule="evenodd"
        fill="#5863ff"
      />
    </BaseIcon>
  );
}
